import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react'
import { createModel } from 'hox'
import useGlobalModel, { transPgToPagination } from '@/erp_subpackage/model/globalModel'
import { convertRes2Blob } from '@/erp_subpackage/utils/exportFile'
import { allocService } from './inventoryStatisticsService'
import { message } from 'antd'

export const useAllocModel = createModel(function () {
    const {
        user: { shopId },
        setLoadingInfo,
    } = useGlobalModel()
    const initPgCfg = { pageSize: 15, current: 1 }

    //查询条件
    const [searchParam, setSearchParam] = useState({})
    //列表数据源
    const [dataSource, setDataSource] = useState([])
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState()
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState(initPgCfg)
    //列表统计展示数据
    const [loading, setLoading] = useState(false)
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState([])

    const updateSearchParam = (updateParam) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //占用库存可查明细 弹框
    const [stockQueryModal, setStockQueryModal] = useState(null)

    //切换门店重置缓存
    useEffect(() => {
        setSearchParam({})
    }, [shopId])

    //重置
    const resetSearchParam = () => {
        setSearchParam({})
        loadData(initPgCfg, {})
    }

    const loadData = async (page = initPgCfg, searchValue = searchParam) => {
        setLoading(true)
        const searchParams = {
            searchItem: {
                shopId,
                ...searchValue,
                materialCode: searchValue?.materialCode?.trim() ?? undefined,
                materialName: searchValue?.materialName?.trim() ?? undefined,
                code: searchValue?.code?.trim() ?? undefined,
                outShopName: searchValue?.outShopName?.trim() ?? undefined,
                shopName: searchValue?.shopName?.trim() ?? undefined,
            },
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? initPgCfg.pageSize,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? initPgCfg.current,
        }
        let { retData } = await allocService.page(searchParams)
        const { list, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(list)
        setLoading(false)
    }

    //导出
    const exportOut = async (searchValue = searchParam) => {
        try {
            const searchParams = {
                shopId,
                ...searchValue,
                materialCode: searchValue?.materialCode?.trim() ?? undefined,
                materialName: searchValue?.materialName?.trim() ?? undefined,
                code: searchValue?.code?.trim() ?? undefined,
                outShopName: searchValue?.outShopName?.trim() ?? undefined,
                shopName: searchValue?.shopName?.trim() ?? undefined,
                pageSize: -1,
                pageNum: 1,
            }
            let result = await allocService.export(searchParams)
            message.success(result.retData)
        } catch {}
    }

    return {
        searchParam,
        loading,
        dataSource,
        pgCfg,
        setDataSource,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportOut,
        selectedRow,
        setSelectedRow,
        selectedRowKeys,
        setSelectedRowKeys,
        stockQueryModal,
        setStockQueryModal,
    }
})
